import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "@/lib/drivers/tandem/TandemTypes";

export type CannulaFilledPayload = {
  prime_size: number;
};

export type CannulaFilledEvent = {
  primeSize: number;
};

const cannulaFilledSchema = z.object({
  prime_size: z.number(),
});

export const LID_CANNULA_FILLED = {
  value: 0x3d,
  name: "Cannula Filled Event",
  format: "f............",
  fields: ["prime_size"],
  postprocess: rec => ({
    primeSize: rec.prime_size,
  }),
  schema: cannulaFilledSchema,
} as const satisfies TandemEventDefinition<CannulaFilledPayload, CannulaFilledEvent>;
